import { Button } from '@/components/ui/button';

const BOOKING_URL = "https://link.sweatsetter.com/widget/booking/0bvqp14e0y6pNvAdcqsM";

export default function MobileCTA() {
  return (
    <div className="mobile-sticky-cta" data-testid="mobile-sticky-cta">
      <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="block">
        <Button 
          className="w-full bg-[#FF5A3C] hover:bg-[#E64526] text-white rounded-none font-nav uppercase tracking-widest py-4 shadow-lg"
          data-testid="mobile-cta-btn"
        >
          Book Free Intro
        </Button>
      </a>
    </div>
  );
}
